<template>
  <v-dialog v-model="openWindow" persistent width="60%" class="delivery-dialog">
    <v-card>
      <v-card-title>
        <v-row align="center" justify="space-between" no-gutters>
          <span>
            Client: {{ clientName }} &nbsp; &nbsp; Livraison/Commande #{{
              delivery.id_commande
            }}
          </span>
          <v-btn icon @click.native="openWindow = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :items="productsForm"
          :headers="headers"
          hide-default-footer
        >
          <template v-slot:item.lundi="{ item }">
            <v-text-field
              v-model="item.lundi"
              single-line
              flat
              solo
              type="number"
              :min="0"
              :height="20"
              hide-details
              @focus="$event.target.select()"
            ></v-text-field>
          </template>
          <template v-slot:item.mardi="{ item }">
            <v-text-field
              v-model="item.mardi"
              single-line
              flat
              solo
              type="number"
              :min="0"
              :height="20"
              hide-details
              @focus="$event.target.select()"
            ></v-text-field>
          </template>
          <template v-slot:item.mercredi="{ item }">
            <v-text-field
              v-model="item.mercredi"
              single-line
              flat
              solo
              type="number"
              :min="0"
              :height="20"
              hide-details
              @focus="$event.target.select()"
            ></v-text-field>
          </template>
          <template v-slot:item.jeudi="{ item }">
            <v-text-field
              v-model="item.jeudi"
              single-line
              flat
              solo
              type="number"
              :min="0"
              :height="20"
              hide-details
              @focus="$event.target.select()"
            ></v-text-field>
          </template>
          <template v-slot:item.vendredi="{ item }">
            <v-text-field
              v-model="item.vendredi"
              single-line
              flat
              solo
              type="number"
              :min="0"
              :height="20"
              hide-details
              @focus="$event.target.select()"
            ></v-text-field>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-row align="center" justify="end" no-gutters>
          <v-btn color="primary" @click="update">Enregistrer</v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
export default {
  name: "CustomerAccountDeliveryUpdateDialog",
  props: [
    "isOpen",
    "store",
    "client",
    "delivery",
    "products",
    "productsPrice",
    "deliveryDetails"
  ],
  computed: {
    openWindow: {
      get: function() {
        return this.isOpen;
      },
      set: function(value) {
        this.$emit("update:isOpen", value);
      }
    },
    clientName: function() {
      return typeof this.client !== "undefined" ? this.client.nom : null;
    }
  },
  data() {
    return {
      productsForm: [],
      headers: [
        { value: "produit", text: "Produit" },
        { value: "lundi", text: "Lundi", width: 100 },
        { value: "mardi", text: "Mardi", width: 100 },
        { value: "mercredi", text: "Mercredi", width: 100 },
        { value: "jeudi", text: "Jeudi", width: 100 },
        { value: "vendredi", text: "Vendredi", width: 100 }
      ],
      days: ["lundi", "mardi", "mercredi", "jeudi", "vendredi"]
    };
  },
  methods: {
    update: function() {
      const config = {
        headers: { Authorization: "JWT " + this.$store.getters["getIdToken"] }
      };
      for (let product of this.productsForm) {
        for (let day of this.days) {
          let editedDetails = this.deliveryDetails.find(
            dd => dd.produit === product.productId && dd.jour === day
          );
          let url =
            "ogari/compte-client/api/sales-details/update/" +
            this.$store.getters["getStoreId"] +
            "/" +
            editedDetails.id +
            "/";
          let data = {
            pk: editedDetails.id,
            quantite: product[day]
          };
          axios.patch(url, data, config).catch(error => {
            console.error(error);
          });
        }
      }
      this.openWindow = false;
      this.$emit("updateTable");
    }
  },
  watch: {
    isOpen: function(e) {
      if (e === true) {
        this.productsForm = [];
        this.products.forEach(p => {
          this.productsForm.push({
            productId: p.id_produit,
            produit: p.nom,
            lundi: 0,
            mardi: 0,
            mercredi: 0,
            jeudi: 0,
            vendredi: 0
          });
          this.deliveryDetails
            .filter(dd => dd.produit === p.id_produit)
            .forEach(d => {
              let day = d.jour;
              this.productsForm.find(pf => pf.productId === p.id_produit)[day] =
                d.quantite;
            });
        });
      }
    }
  }
};
</script>

<style scoped></style>
